// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import { MY_SCOPE_TYPES_IN_PROJECT } from '../../gql/auth';
import PropTypes from 'prop-types';
import { containsOneOf } from '../../utils';
// import { NotAuthorisedInProject } from 'components/layout/ErrorPage';
import ProjectHeader from 'components/project/ProjectHeader';
import { PageContainer } from '@ant-design/pro-layout';

/**
 *
 * @param {[string]} expectedScopeType - show children if contains one of the expected scope types
 * @returns
 */
const PrivateComponentInProject = ({ expectedScopeType, render, children }) => {
  const { projectId } = useParams();
  const hasExpectedScopeType = containsOneOf(expectedScopeType);

  const { data, loading } = useQuery(MY_SCOPE_TYPES_IN_PROJECT, {
    variables: {
      projectId,
    },
  });

  if (loading)
    return (
      <ProjectHeader>
        <PageContainer loading={loading} />
      </ProjectHeader>
    );

  if (
    data?.myScopeTypesInProject?.viewProject &&
    hasExpectedScopeType(data?.myScopeTypesInProject?.scopeTypes)
  ) {
    return children;
  } else {
    return render;
  }
};

PrivateComponentInProject.defaultProps = {
  render: <></>,
};

PrivateComponentInProject.propTypes = {
  expectedScopeType: PropTypes.array.isRequired,
  render: PropTypes.node.isRequired,
};

export default PrivateComponentInProject;
